
module dg.navigation {

    class ReloadController implements ng.IController {
        public constructor(
            private $state: ng.ui.IStateService
        ) {

        }

        $onInit() {

        }

        public reload() {
            this.$state.reload();
        }
    }
        
    angular.module('dg.navigation').component('reload', {
        controller: ReloadController,
        templateUrl: '/digmo/src/navigation/reload.html'
    });
}